
import { aiProxy } from "./aiProxy";

/**
 * VECTOR DATABASE SERVICE (Simulation)
 * 
 * In a full production 2026 architecture, this service would connect to 
 * Pinecone, Weaviate, or Firestore Vector Search.
 * 
 * Now refactored to use SECURE PROXY to protect API keys.
 */

// 1. Generate an Embedding Vector for a string
export const generateEmbedding = async (text: string): Promise<number[]> => {
    try {
        return await aiProxy.embedContent({
            text: text
        } as any); // The proxy handles the wrapping
    } catch (e) {
        console.error("Embedding Error:", e);
        return [];
    }
};

// ... (cosineSimilarity remains same)

// 3. Semantic Search Function
export const performSemanticSearch = async (query: string, documents: { id: string; content: string; metadata: any }[]) => {
    console.log(`[VECTOR DB] Vectorizing Query: "${query}"`);
    
    const prompt = `
        You are acting as a Vector Database Semantic Search Engine.
        
        Task: Rank the following documents based on their semantic relevance to the User Query.
        User Query: "${query}"
        
        Documents:
        ${JSON.stringify(documents.map(d => ({ id: d.id, preview: d.content.substring(0, 200) })))}
        
        Return strictly a JSON array of the top 3 matching IDs, like: ["id1", "id2"].
        If nothing matches, return [].
    `;

    try {
        const text = await aiProxy.generateContent({
            contents: [{ role: 'user', parts: [{ text: prompt }] }],
            config: { responseMimeType: "application/json" }
        });
        
        const topIds = JSON.parse(text || "[]");
        return documents.filter(d => topIds.includes(d.id));
    } catch (e) {
        console.error("Vector Search Simulation Failed", e);
        return [];
    }
};

/**
 * 4. Document Intelligence (RAG)
 */
export const queryDocument = async (question: string, docText: string) => {
    const prompt = `
        Context (Retrieved from Vector Store):
        ${docText}
        
        User Question: ${question}
        
        Answer the question based strictly on the context provided.
    `;
    
    return await aiProxy.generateContent({
        contents: [{ role: 'user', parts: [{ text: prompt }] }]
    });
};
